import React from 'react'
import "./Users.css";
import "../App.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from 'react-bootstrap/Card';
import { MdOutlineStar } from "react-icons/md";
import { IconContext } from "react-icons";
import { FaQuoteLeft } from "react-icons/fa";


const Cr = () => {
    const stars = Array(5).fill(<MdOutlineStar />);
    var settings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: "ease-out",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    infinite: true,
                    dots: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                }
            }
        ]
    };
    return (
        <>

            <div className=' mainusers'>

                <div className='userstext'>
                    <h5>
                    Trusted Voices
                    </h5>
                    <p>
                    We pride ourselves on making dreams come true. Discover how we’ve helped them find their dream properties, 
                        <br></br>and how we can do the same for you
                    </p>
                </div>







                <div className='usersslider'>
                    <Slider {...settings}>
                        <div className='user-card-container'>
                            <Card className="usercard" style={{ width: 'auto', borderRadius: '10px' }}>
                                <Card.Body className='userscardbody'>
                                    <Card.Title className='quotes'>
                                        <IconContext.Provider value={{ className: "iquotes" }}>
                                            <FaQuoteLeft />
                                        </IconContext.Provider>
                                    </Card.Title>
                                    <Card.Text className='usercoment cardtext'>
                                "Over the past few years, I’ve acquired 4 amazing plots in Dholera, Gujarat. I’ve never felt more confident about my investments!"
                                    </Card.Text>
                                    <Card.Text className='userstars'>
                                        <IconContext.Provider value={{ className: "istar" }}>
                                            {stars}
                                        </IconContext.Provider>
                                    </Card.Text>
                                </Card.Body>
                                <div className="arrow"></div>
                            </Card>
                            <div className='userdetails'>
                                <div className='usersimagediv'>
                                    <img className='userscardimg' src="/assets/Tinu.jpg"  alt='Abhishek - Advocate'/>
                                </div>
                                <div className='usersimagetext'>
                                    <h5>Abhishek</h5>
                                    <p>Advocate</p>
                                </div>
                            </div>
                        </div>







                        <div className='user-card-container'>
                            <Card className="usercard" style={{ width: 'auto', borderRadius: '10px' }}>
                                <Card.Body className='userscardbody'>
                                    <Card.Title className='quotes'>
                                        <IconContext.Provider value={{ className: "iquotes" }}>
                                            <FaQuoteLeft />
                                        </IconContext.Provider>
                                    </Card.Title>
                                    <Card.Text className='usercoment cardtext'>
                                    "Securing 3 plots in Dholera, Gujarat has been an incredible journey! The future here looks promising, and I’m excited to be part of it."
                                    </Card.Text>
                                    <Card.Text className='userstars'>
                                        <IconContext.Provider value={{ className: "istar" }}>
                                            {stars}
                                        </IconContext.Provider>
                                    </Card.Text>
                                </Card.Body>
                                <div className="arrow"></div>
                            </Card>
                            <div className='userdetails'>
                                <div className='usersimagediv'>
                                    <img className='userscardimg' src="/assets/Sheel.jpg" alt='Sheel - Real Estate Investor' />
                                </div>
                                <div className='usersimagetext'>
                                    <h5> Sheel</h5>
                                    <p>Real Estate Investor</p>
                                </div>
                            </div>
                        </div>








                        <div className='user-card-container'>
                            <Card className="usercard" style={{ width: 'auto', borderRadius: '10px' }}>
                                <Card.Body className='userscardbody'>
                                    <Card.Title className='quotes'>
                                        <IconContext.Provider value={{ className: "iquotes" }}>
                                            <FaQuoteLeft />
                                        </IconContext.Provider>
                                    </Card.Title>
                                    <Card.Text className='usercoment cardtext'>
                                    "I couldn’t have asked for a better spot! My plot in the heart of Mussoorie’s prime location this magnificent view is everything I hoped for."
                                    </Card.Text>
                                    <Card.Text className='userstars'>
                                        <IconContext.Provider value={{ className: "istar" }}>
                                            {stars}
                                        </IconContext.Provider>
                                    </Card.Text>
                                </Card.Body>
                                <div className="arrow"></div>
                            </Card>
                            <div className='userdetails'>
                                <div className='usersimagediv'>
                                    <img className='userscardimg' src="/assets/Poonam.jpg"  alt='Aarti - Teacher' />
                                </div>
                                <div className='usersimagetext'>
                                    <h5>Aarti</h5>
                                    <p>Teacher</p>
                                </div>
                            </div>
                        </div>








                        <div className='user-card-container'>
                            <Card className="usercard" style={{ width: 'auto', borderRadius: '10px' }}>
                                <Card.Body className='userscardbody'>
                                    <Card.Title className='quotes'>
                                        <IconContext.Provider value={{ className: "iquotes" }}>
                                            <FaQuoteLeft />
                                        </IconContext.Provider>
                                    </Card.Title>
                                    <Card.Text className='usercoment cardtext'>
                                    "I couldn’t be more thrilled with my investment! Just secured 2 prime plots in Dholera, Gujarat. It’s a dream come true!"
                                    </Card.Text>
                                    <Card.Text className='userstars'>
                                        <IconContext.Provider value={{ className: "istar" }}>
                                            {stars}
                                        </IconContext.Provider>
                                    </Card.Text>
                                </Card.Body>
                                <div className="arrow"></div>
                            </Card>
                            <div className='userdetails'>
                                <div className='usersimagediv'>
                                    <img className='userscardimg' src="/assets/Samrat.jpg" alt='Samrat - Real Estate Investor' />
                                </div>
                                <div className='usersimagetext'>
                                    <h5>Samrat</h5>
                                    <p>Real Estate Investor</p>
                                </div>
                            </div>
                        </div>







                        <div className='user-card-container'>
                            <Card className="usercard" style={{ width: 'auto', borderRadius: '10px' }}>
                                <Card.Body className='userscardbody'>
                                    <Card.Title className='quotes'>
                                        <IconContext.Provider value={{ className: "iquotes" }}>
                                            <FaQuoteLeft />
                                        </IconContext.Provider>
                                    </Card.Title>
                                    <Card.Text className='usercoment cardtext'>
                                    "Investing in both Mussoorie’s prime location and Garh’s Best Sellers has been a fantastic experience. Two plots in two perfect spots!"
                                    </Card.Text>
                                    <Card.Text className='userstars'>
                                        <IconContext.Provider value={{ className: "istar" }}>
                                            {stars}
                                        </IconContext.Provider>
                                    </Card.Text>
                                </Card.Body>
                                <div className="arrow"></div>
                            </Card>
                            <div className='userdetails'>
                                <div className='usersimagediv'>
                                    <img className='userscardimg' src="/assets/Papaji.jpg" alt='Sanjeev - Real Estate Investor' />
                                </div>
                                <div className='usersimagetext'>
                                    <h5>Sanjeev</h5>
                                    <p>Real Estate Investor</p>
                                </div>
                            </div>
                        </div>





                    </Slider>
                </div>

            </div>

        </>
    )
}

export default Cr